import React, { RefObject } from "react";
import { LayoutDashboardIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { images } from "../data/offer";
type HeroProps = {
  firstCtaRef: RefObject<HTMLDivElement>;
};
export function Hero({
  firstCtaRef
}: HeroProps) {
  return <header className="bg-canvas px-4 pb-14 pt-6 md:pb-20 md:pt-10" data-id="element-186" data-mp="4mrxb9ifkfpg">
      <div className="mx-auto max-w-5xl text-center" data-id="element-187" data-mp="1297f6cerrfdj">
        <div className="inline-flex items-center gap-2.5 rounded-full border border-navy-900/10 bg-white py-1.5 pl-1.5 pr-4 shadow-sm" data-id="element-188" data-mp="128phrcgdev41">
          <span className="grid h-8 w-8 place-items-center rounded-full bg-navy-900 text-brand-cyan" data-id="element-189" data-mp="sb1ajn1kvv4z">
            <LayoutDashboardIcon className="h-4 w-4" aria-hidden="true" data-id="element-190" data-mp="ncgjad4b0lso" />
          </span>
          <span className="text-[13px] font-extrabold tracking-wide text-navy-900" data-id="element-191" data-mp="3d1ii934hv0k9">
            ORTHO CASE <span className="text-brand" data-id="element-192" data-mp="382fgpsnq3ch1">COMMAND CENTER™</span>
          </span>
        </div>

        <p className="mt-5 text-[15px] font-semibold text-brand md:text-base" data-id="element-193" data-mp="384s2yi0ik8zw">The Visual Case Planning System for Orthodontic Professionals</p>

        <h1 className="mx-auto mt-3 max-w-4xl font-serif text-[36px] font-extrabold leading-[1.08] text-ink md:text-6xl" data-id="element-194" data-mp="3o6ki7px9iq8t">
          Organize your next orthodontic case into a clear visual strategy in{" "}
          <em className="text-brand" data-id="element-195" data-mp="3e84orgarj4w5">15 minutes</em>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed text-muted md:text-lg" data-id="element-196" data-mp="30iayquniueku">
          — without starting from a blank page. Inside, you'll get <strong className="text-ink" data-id="element-197" data-mp="35a2fyeksf7yb">6 premium volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-198" data-mp="2qkwiav1llpsj">5 professional tools</strong> and <strong className="text-ink" data-id="element-199" data-mp="2viy4vpy8g78r">30+ visual planning protocols</strong>, checklists, matrices and case-mapping worksheets.
        </p>

        <img src={images.product} alt="Ortho Case Command Center™ — 6 volumes, digital tablets and 5 bonus workbooks" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-200" data-mp="2hk886bfbs9kx" />

        <div ref={firstCtaRef} className="mx-auto mt-6 max-w-xl" data-id="element-201" data-mp="s2tenov66frb">
          <CTAButton label="I want the Ortho Case Command Center™" data-id="element-202" data-mp="nbl0ygmt488c" />
        </div>
        <p className="mx-auto mt-3 max-w-xl text-sm text-muted" data-id="element-203" data-mp="ic873bxiq0w9">
          Immediate digital access · One-time payment of <strong className="text-ink" data-id="element-204" data-mp="ddf4iejrruav">USD $27</strong> · Lifetime access · 7-Day Guarantee
        </p>

        <div className="mt-8" data-id="element-205" data-mp="1b1fg54ulm8vr">
          <Countdown data-id="element-206" data-mp="1azkutpff0er5" />
        </div>
      </div>
    </header>;
}